<template>
  <div>
    <v-select dense v-model="timeModel" :items="times" :label="label" @input="updateTime"/>
  </div>
</template>

<script>
export default {
  props: ['value', 'label'],
  watch: {
    'value' (to) {
      this.timeModel = to
    }
  },
  methods: {
    updateTime () {
      // alert(this.timeModel)
      this.$emit('input', this.timeModel)
    }
  },
  data () {
    return {
      timeModel: this.value,
      times: [
        {value: '00:00', text: 'Midnight'},
        {value: '00:30', text: '12:30 am'},
        {value: '01:00', text: '1 am'},
        {value: '01:30', text: '1:30 am'},
        {value: '02:00', text: '2 am'},
        {value: '02:30', text: '2:30 am'},
        {value: '03:00', text: '3 am'},
        {value: '03:30', text: '3:30 am'},
        {value: '04:00', text: '4 am'},
        {value: '04:30', text: '4:30 am'},
        {value: '05:00', text: '5 am'},
        {value: '05:30', text: '5:30 am'},
        {value: '06:00', text: '6 am'},
        {value: '06:30', text: '6:30 am'},
        {value: '07:00', text: '7 am'},
        {value: '07:30', text: '7:30 am'},
        {value: '08:00', text: '8 am'},
        {value: '08:30', text: '8:30 am'},
        {value: '09:00', text: '9 am'},
        {value: '09:30', text: '9:30 am'},
        {value: '10:00', text: '10 am'},
        {value: '10:30', text: '10:30 am'},
        {value: '11:00', text: '11 am'},
        {value: '11:30', text: '11:30 am'},
        {value: '12:00', text: 'Noon'},
        {value: '12:30', text: '12:30 pm'},
        {value: '13:00', text: '1 pm'},
        {value: '13:30', text: '1:30 pm'},
        {value: '14:00', text: '2 pm'},
        {value: '14:30', text: '2:30 pm'},
        {value: '15:00', text: '3 pm'},
        {value: '15:30', text: '3:30 pm'},
        {value: '16:00', text: '4 pm'},
        {value: '16:30', text: '4:30 pm'},
        {value: '17:00', text: '5 pm'},
        {value: '17:30', text: '5:30 pm'},
        {value: '18:00', text: '6 pm'},
        {value: '18:30', text: '6:30 pm'},
        {value: '19:00', text: '7 pm'},
        {value: '19:30', text: '7:30 pm'},
        {value: '20:00', text: '8 pm'},
        {value: '20:30', text: '8:30 pm'},
        {value: '21:00', text: '9 pm'},
        {value: '21:30', text: '9:30 pm'},
        {value: '22:00', text: '10 pm'},
        {value: '22:30', text: '10:30 pm'},
        {value: '23:00', text: '11 pm'},
        {value: '23:30', text: '11:30 pm'}
      ]
    }
  }
}
</script>